import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  problem: 'Nights lost searching for lessons that actually work for Grades 9–12',
  impact: 'Your energy is gone before class even starts'
}, {
  problem: 'Units that feel disconnected — because they were built piece by piece',
  impact: 'Students lose the thread and disengage'
}, {
  problem: 'Visible improvisation that quietly chips away at your confidence',
  impact: 'You second-guess yourself in front of the room'
}, {
  problem: 'No variety across weeks — same activities, same format, every time',
  impact: 'Students stop caring and you feel it'
}, {
  problem: 'Weekends spent planning instead of resting or living your life',
  impact: 'Burnout builds — and it shows in your teaching'
}];
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-164" data-mp="3ibi6o8v5xt4p">
      <div className="max-w-4xl mx-auto" data-id="element-165" data-mp="3ncxta5czo7p7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-166" data-mp="3nbwfvu8i394b">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-167" data-mp="1u1buvbhor1yx">
            💬 Does This Sound Familiar?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border" data-id="element-168" data-mp="23rdik264midb">
            It&apos;s Sunday. 10 PM. You have Food Science first period tomorrow
            morning. And you&apos;re still sitting there — searching for a decent
            activity on fermentation, trying to remember where you saved that
            food safety worksheet, wondering if what you&apos;ve pulled together
            will actually land with a room full of ninth graders.
            <br data-id="element-169" data-mp="30he3fq3dkepc" />
            <br data-id="element-170" data-mp="30guxz8uwvis7" />
            <span className="text-gold-light font-medium" data-id="element-171" data-mp="30gcsdlmczs7m">
              Not because you don&apos;t know Food Science.
            </span>{' '}
            Because no one ever gave you a complete, ready-to-teach library.
            You&apos;ve been building every single lesson from zero. The time you
            should be resting — you spend planning. And the worst part isn&apos;t the
            exhaustion. It&apos;s walking into the classroom knowing you could have
            been more prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-172" data-mp="272tsv8rixqxu">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-173" data-mp="1ehag2mr9wjgr">
            🔴 The Real Cost of Not Having the Right Resource
          </h3>
          <div className="overflow-hidden rounded-xl border border-red-900/30 bg-dark-card" data-id="element-174" data-mp="1jdipdjishig0">
            <div className="hidden sm:grid grid-cols-2 bg-red-950/30 text-xs uppercase tracking-wider font-bold text-red-200" data-id="element-175" data-mp="1o7wr03o1olt4">
              <p className="px-5 py-3" data-id="element-176" data-mp="vphlinwk2q6x">The Problem</p>
              <p className="px-5 py-3 border-l border-red-900/30" data-id="element-177" data-mp="vny8r7a3yx9w">The Real Impact</p>
            </div>
            {painPoints.map((point, index) => <motion.div key={point.problem} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="grid sm:grid-cols-2 border-t first:border-t-0 border-red-900/30" data-id="element-178" data-mp="j6nhuxjtr7bh" data-mpi={index}>
                <p className="px-5 py-4 text-gray-200 text-sm leading-relaxed" data-id="element-179" data-mp="59793fe231gk">
                  <span className="mr-2" data-id="element-180" data-mp="fcrqilxaykn">❌</span>{point.problem}
                </p>
                <p className="px-5 pb-4 sm:py-4 text-gray-400 text-sm leading-relaxed sm:border-l border-red-900/30" data-id="element-181" data-mp="3rni7vcfiwx85">
                  <span className="mr-2 sm:hidden" data-id="element-182" data-mp="3mlsuhq4tw7gw">💥</span>{point.impact}
                </p>
              </motion.div>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-183" data-mp="3dmxoae1saxdl">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-184" data-mp="1hkb2umr529oo">
              ⚡ Stop giving away your free time. Your dedication is already
              there. What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-185" data-mp="17v17my100awc">
              📅 Solve a full year of Food Science classes in just 5 minutes today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}